import React, { useEffect, useState } from "react";
import usePrescriptionStore from "modules/prescribed_patients/store";
import { useLocation, useNavigate } from "react-router-dom";
import PrescribedInputDate from "modules/prescribed_patients/PrescribedInputDate";
import PaginationDiv from "modules/pagination/PaginationDiv";
import PrescribedTable from "modules/prescribed_patients/PrescribedTable";
import { usePrescribedPatientsCount } from "./store";
import CardDiv from "modules/common/card-div/CardDiv";

function PrescribedPatients() {
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const startDate = searchParams.get("startDate");
  const endDate = searchParams.get("endDate");
  const [page, setPage] = useState(1);
  const [startFilterDate, setStartFilterDate] = useState("");
  const [endFilterDate, setEndFilterDate] = useState("");
  const [pageNo, newPage] = useState(1);

  const { prescriptionData, prescriptionLoading, fetchPrescriptionData } =
    usePrescriptionStore();
  const { fetchPrescribedPatientsCount, count } = usePrescribedPatientsCount();
  useEffect(() => {
    if (startFilterDate && endFilterDate) {
      fetchPrescriptionData(startFilterDate, endFilterDate, pageNo);
      fetchPrescribedPatientsCount(startFilterDate, endFilterDate);
    } else {
      fetchPrescriptionData(startDate, endDate, pageNo);
      fetchPrescribedPatientsCount(startDate, endDate);
    }
  }, [startFilterDate, endFilterDate, startDate, endDate, pageNo]);

  const formatOrderStatus = (status) => {
    return status
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  return (
    <>
      <CardDiv
        title={
          <div className="d-flex flex-row justify-content-between align-items-center my-n2 gap-1">
            <div>Prescribed Patient</div>
            {count.data && (
              <div className="text-primary">
                {count?.data?.map((Order) => (
                  <span
                    key={Order.status}
                    className="mx-1 shadow-sm px-2 border rounded text-secondary"
                  >
                    {formatOrderStatus(Order.status)}:
                    <span className="text-primary"> {Order.order_count} </span>
                  </span>
                ))}
                <span
                  className="mx-1 shadow-sm px-2 border rounded text-secondary"
                >
                  Total:
                  <span className="text-primary"> {prescriptionData?.pagination?.rowCount} </span>
                </span>
              </div>
            )}
            <div>
              <PrescribedInputDate
                setStartDate={setStartFilterDate}
                setEndDate={setEndFilterDate}
              />
            </div>
          </div>
        }
        component={
          <>
            <PrescribedTable
              prescriptionData={prescriptionData}
              prescriptionLoading={prescriptionLoading}
            />

            <PaginationDiv
              paginationData={{
                pageCount: prescriptionData?.pagination?.pageCount || 1,
                page: prescriptionData?.pagination?.page,
              }}
              newPage={newPage}
            />
          </>
        }
      />
    </>
  );
}

export default PrescribedPatients;
